// JavaScript code for sn/menus/desktop-header-menu component
(($) => {

    "use strict";
    console.log("sn/menus/desktop-header-menu scripts loaded...");

    let isSliding = false;

    $('.desktop-header-menu > li.menu-item-has-children > a').on('click', function (e) {
        e.preventDefault();
        if (isSliding) return;

        isSliding = true;
        // if I click on the already active menu item, just close the mega menu
        if ($(this).parent('li').hasClass('active')) {
            $(this).parent('li').removeClass('active');
            $('.mega-menu-holder').slideUp(250);
            isSliding = false;
            return;
        }

        $(this).parent('li').toggleClass('active').siblings().removeClass('active');
        const $relatedMegaMenu = $(this).next('.mega-menu').clone();
        $relatedMegaMenu.addClass('active');
        $('.mega-menu-holder').slideUp(250, function () {
            $(this).empty();
            $(this).append($relatedMegaMenu).slideDown(250);
            isSliding = false;
        });
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('.main-header').length) return;
        if ($('.desktop-header-menu > li.active').length) {
            $('.desktop-header-menu > li.active > a').trigger('click');
        }
    });

})(jQuery);